import { Loading } from '@fasstech/middle-design-system';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import useGetSimulationRecapQuery from '@@views/simulationRecap/client/hooks/useGetSimulationRecapQuery.js';
import SimulationRecapGroupProtectionForm from './SimulationRecapGroupProtectionForm.jsx';

const SimulationRecapGroupProtection = ({
  getMiddleText,
  getMiddleBoolean,
  regimeObligatoire
}) => {
  const { getSimulationRecap, loading: isFetchingGetSimulationRecap } =
    useGetSimulationRecapQuery();

  if (isFetchingGetSimulationRecap) return <Loading />;

  return (
    <SimulationRecapGroupProtectionForm
      getSimulationRecap={getSimulationRecap}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      regimeObligatoire={regimeObligatoire}
    />
  );
};

SimulationRecapGroupProtection.propTypes = {
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func
};

export default compose(withMiddleFeatures, withGlobalData)(SimulationRecapGroupProtection);
